import React from 'react'
import { useParams } from 'react-router-dom';
import { Gatedcommunities } from './Gatedcommunities';


export const GatedcommunitiesWrapper = () => {
    const { type } = useParams();
     const readableType = type
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
  return (
    <div>
        <Gatedcommunities projecttype = {readableType}/>
    </div>
  )
}
